import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { caseActions } from "../../../../store/case";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import InputBox from "../../../common/interactive/InputBox";

function claimNumberLabel(prefix) {
    if (prefix === 'pip_') return 'PIP Claim #'
    if (prefix === 'mp_') return 'MP Claim #'
    if (prefix === 'um_') return 'UM Claim #'
    return 'Claim #'
}

export default function UpdatableClaimNumber({data, itemId, caseType, folder, prefix}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const fieldKey = prefix ? `${prefix}claim_number` : 'claim_number'
    const borderFlag = prefix === 'pip_' || prefix === 'mp_' || prefix === 'um_' ? 'redBorderFlag' : 'yellowBorderFlag'

    const updateHandler = async (data) => {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }   
        
        let dispatchBody = {
            folder: folder,
            item: {
                itemId: itemId,
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    },
                ]            
            }
        }


        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }     
        
    }


    return <InputBox type={'text'} action={updateHandler} label={claimNumberLabel(prefix)} currentValue={data[fieldKey]} identifier={{type: caseType, field: fieldKey, type_id: itemId, permissionType: prefix === 'um_' ? 'um' : undefined}} {...{[borderFlag]: !data[fieldKey]}}/>
}
